import axios from 'src/utils/axios';

export const GET_ALL_LEAD = '@lead/get-all-lead';
export const ADD_LEAD = '@lead/add-lead';
export const UPDATE_LEAD = '@lead/update-lead';
export const DELETE_LEAD = '@lead/delete-lead';
export const GET_ONE_LEAD = '@lead/get-one-lead';
export const LAST_SEEN = '@lead/last-seen';

export function getAllLead(botId) {
  const request = axios.get(`/api/leads/all/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_ALL_LEAD,
        payload: response.data
      })
    );
  };
}
export function getOneLead(id) {
  const request = axios.get(`/api/leads/${id}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_ONE_LEAD,
        payload: response.data
      })
    );
  };
}

export function addOneLead(lead) {
  const request = axios.post(`/api/leads/add`, {
    lead
  });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_LEAD,
        payload: response.data
      })
    );
  };
}

export function updateLead(lead) {
  const request = axios.put(`/api/leads/update`, {
    lead
  });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: UPDATE_LEAD,
        payload: response.data
      })
    );
  };
}

export function deleteLead(id) {
  const request = axios.delete(`/api/leads/delete/${id}`);

  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_LEAD,
        payload: { id } //pasar id
      })
    );
  };
}
